import {
  styled,
  Table,
  TableCell,
  tableCellClasses,
  TableRow,
} from '@mui/material';
import React from 'react';
import theme from '../styles/theme';
import { CustomPaper, CustomTableContainer } from './Calendar';

type TableProps = {
  isFullWidth?: boolean;
  bordered?: boolean;
  highlightFirstColumn?: boolean;
  hoverable?: boolean;
  navHeight?: string;
  autoHeight?: boolean;
  style?: {};
  children: React.ReactNode;
};
type HeaderCellProps = {
  backgroundColor?: string;
  color?: string;
};
export const StyledBodyCell = styled(TableCell)<{ verticalAlignCustom?: string }>(({ verticalAlignCustom }) => ({
  [`&.${tableCellClasses.body}`]: {
    color: 'black',
    borderBottom: '2px solid #F4F5F7',
    fontFamily: 'Poppins',
  },
  [`&.${tableCellClasses.root}`]: {
    verticalAlign: verticalAlignCustom
  },
}));
export const StyledHeaderCell = styled(TableCell)<HeaderCellProps>(
  ({ backgroundColor, color }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: backgroundColor ? backgroundColor : '#090a14',
      color: color ? color : 'white',
      fontFamily: 'Poppins',
      padding: '8px 16px',
    },
  }),
);

export const StyledTableRow = styled(TableRow)(() => ({
  scrollMarginTop: '40px',
  verticalAlign: 'baseline',
  color:'red',

  '&.MuiTableRow-root': {
    verticalAlign: 'baseline',
  },
  '&.Mui-selected': {
    background: '#e9e9e9 !important',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    '.MuiTableCell-body': {
      color: '#0000b5',
      fontWeight:'bold',

      // textShadow:'0 4px 4px gray'
    },
    '&:hover': {
      // backgroundColor: 'rgb(65 74 86 / 83%) !important',
      color: 'white',
      cursor: 'pointer',
      fontFamily: 'Poppins',
      '.MuiTableCell-body': {
        // color: 'white',
      },
    },
  },

  // '&:hover': {
  //   backgroundColor: `${theme.color.hoverColor} !important`,
  //   // textShadow:'0 4px 4px gray',
  //   color: 'white',
  //   cursor: 'pointer',
  //   fontFamily: 'Poppins',
  //   '.MuiTableCell-body': {
  //     color: '#0000b5',
  //   },
  // },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
    fontFamily: 'Poppins',
  },
}));
export const StyledTableRowNoHover = styled(TableRow)(() => ({
  scrollMarginTop: '40px',
  verticalAlign: 'baseline',
  '&.MuiTableRow-root': {
    verticalAlign: 'baseline',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
    fontFamily: 'Poppins',
  },
}));
function TableComponent(props: TableProps) {
  const { navHeight, autoHeight, children, style } = props;
  return (
    // <CustomPaper
    //   sx={{
    //     width: '100%',
    //     background: 'transparent',
    //     color: 'white',
    //   }}>
    <CustomTableContainer height={navHeight} autoHeight={autoHeight} style={style} className="visible-scrollbar">
      <Table stickyHeader aria-label="sticky table">
        {children}
      </Table>
    </CustomTableContainer>
    // </CustomPaper>
  );
}
// const Table = styled.table<TableProps & React.HTMLProps<HTMLTableElement>>`
//   overflow: auto;
//   ${({ isFullWidth }) => (isFullWidth ? 'width: 100%;' : 'width: 0px;')};
//   border-spacing: 0;
//   border-collapse: collapse;

//   & > thead > tr:first-child {
//     td,
//     th {
//       padding-top: 0;
//     }
//   }

//   & > tbody:first-child > tr:first-child {
//     td,
//     th {
//       padding-top: 0;
//     }
//   }

//   td {
//     vertical-align: baseline;
//   }

//   th {
//     vertical-align: bottom;
//   }

//   td,
//   th {
//     padding: ${({ theme }) => theme.spacing.x1}
//       ${({ theme }) => theme.spacing.x1};
//     margin: 0;
//     text-align: left;

//     ${({ theme, isFullWidth }) =>
//       !isFullWidth &&
//       `
//     min-width: ${theme.spacing.base * 8}px;
//     white-space: nowrap;
//     `};

//     color: ${({ theme }) => theme.color.textColor};
//     ${({ theme, bordered }) =>
//       bordered
//         ? `border: 1px solid ${theme.color.borderColor};`
//         : `border-bottom: 1px solid ${theme.color.borderColor};`}

//     &:first-child {
//       ${({ theme, highlightFirstColumn }) =>
//         highlightFirstColumn &&
//         `background-color: ${theme.color.lightBackground};`}
//       padding-left: 0;
//     }

//     &:last-child {
//       padding-right: 0;
//     }
//   }

//   thead th {
//     color: ${({ theme }) => theme.color.textColor};
//     ${({ theme, bordered }) =>
//       bordered
//         ? `border: 1px solid ${theme.color.borderColor};`
//         : `border-bottom: 1px solid ${theme.color.primary};`}
//   }

//   td.nowrap {
//     white-space: nowrap;
//   }

//   tbody tr:hover {
//     ${({ hoverable, theme }) =>
//       hoverable &&
//       css`
//         background-color: ${theme.color.lightBackground};
//         cursor: pointer;
//       `};
//   }
// `;

// Table.defaultProps = {
//   isFullWidth: true,
// };

export default TableComponent;
